// ink-component
import React, { ReactElement } from 'react';

import Button from '../../../Button/Button';
import Field from '../../../Field/Field';
import FilePicker from '../../../FilePicker/FilePicker';
import NewTextArea from '../../../NewTextArea/NewTextArea';

import { MessageReplyWrapper, MessageReplyActions, MessagePrompts } from '../../styles';

import getGlobalProps from '../../../../helpers/constants/global-props';

export interface MessageReplyProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Label for the text area */
  label: string;
  /** Reply action using a [Button](/components/Button) component */
  actionButton: ReactElement<typeof Button>;
  /** [FilePicker](/components/FilePicker) component */
  filepicker?: ReactElement<typeof FilePicker>;
  /** [NewTextArea](/components/NewTextArea) component */
  textarea: ReactElement<typeof NewTextArea>;
  /** Prompts as an array of [Button](/components/Button) components. Suggested 3 max but we aren't restricting the array */
  prompts?: ReactElement<typeof Button>[];
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string;
}

const globalProps = getGlobalProps({});

/**
 * @purpose Message attachment
 * @group Message
 */
function MessageReply(props: MessageReplyProps) {
  const {
    className,
    style,
    actionButton,
    children,
    filepicker,
    label,
    prompts,
    textarea,
    'data-testid': dataTestId,
    ...otherProps
  } = props;

  return (
    <MessageReplyWrapper {...globalProps} {...otherProps} data-testid={dataTestId}>
      {prompts && (
        <MessagePrompts data-testid={`${dataTestId}-reply-prompts`}>
          {prompts.map((prompt, index) => (
            <React.Fragment key={index}>{prompt}</React.Fragment>
          ))}
        </MessagePrompts>
      )}

      <Field label={label} isStacked>
        {textarea}
      </Field>

      <MessageReplyActions>
        {filepicker}
        {actionButton}
      </MessageReplyActions>
    </MessageReplyWrapper>
  );
}

MessageReply.defaultProps = {};

MessageReply.displayName = 'Message.Reply';

export default MessageReply;
